import Reflux from "reflux";

export default Reflux.createActions([
  "openCreationDialog",
  "closeCreationDialog",
  "save",
]);
